export const BasicPageHeader = ({ title }: { title: string }) => {
  return (
    <h2 className={"text-2xl font-sans-bold"}>{title}</h2>
  );
};